module.exports = __webpack_public_path__ + "img/fund_img3.36e7a601.png";